// External deps
import { useContext } from 'react';

// Internal deps
import { UserProfileContext} from '../context/UserProfileContext';

export default function useUserProfile() {
  return useContext(UserProfileContext);
}
